import dayjs from 'dayjs';
export var checkAppIsOnCentral = function (app_key, centralProfile) { return (!!(centralProfile === null || centralProfile === void 0 ? void 0 : centralProfile.applications.filter(function (cp) { return cp.app_key === app_key; }).length)); };
export var processReleaseNotesList = function (releaseNotes, centralProfile) {
    if (releaseNotes === null || releaseNotes === void 0 ? void 0 : releaseNotes.length) {
        // Filter published and valid notes
        var publishedNotes = releaseNotes === null || releaseNotes === void 0 ? void 0 : releaseNotes.filter(function (n) { return (n.status === '1' && n.title && checkAppIsOnCentral(n.application, centralProfile) && dayjs(n.releaseDate).isValid()); });
        // Sort notes by release date
        var sorted = publishedNotes.sort(function (a, b) {
            var aReleaseDate = dayjs(a.releaseDate);
            var bReleaseDate = dayjs(b.releaseDate);
            // Compare release dates
            if (!bReleaseDate.isSame(aReleaseDate) && bReleaseDate.isAfter(aReleaseDate)) {
                return 1;
            }
            if (!bReleaseDate.isSame(aReleaseDate) && aReleaseDate.isAfter(bReleaseDate)) {
                return -1;
            }
            // If release dates are equal, compare by createdAt
            var aCreatedAt = dayjs(a.createdAt);
            var bCreatedAt = dayjs(b.createdAt);
            return aCreatedAt.isBefore(bCreatedAt) ? 1 : -1;
        });
        return sorted;
    }
    return null;
};
//# sourceMappingURL=utils.js.map